import { Injectable, inject } from '@angular/core';
import { DisplayGuestDto, DisplayUser, GalleryDto } from '@nusign/picflow-backend-types';
import { map, take } from 'rxjs';
import { ActivityService } from '../../services/activity.service';
import { DisplayGuestEmailDto, DisplayUserEmailDto } from '../../services/visitor.service';

@Injectable({
  providedIn: 'root',
})
export class AssetPageDataService {
  private activityService = inject(ActivityService);

  public getGalleryPeople(
    gallery: GalleryDto,
    people: {
      userOrGuest: DisplayUserEmailDto | DisplayGuestEmailDto;
      assetIds: string[];
      type: 'user' | 'guest';
    }[] = []
  ) {
    return this.activityService.getCurrentGalleryActivity(gallery).pipe(
      take(1),
      map(activities => {
        people.length = 0;
        activities.forEach(activity => {
          if (activity.user) {
            if (!people.find(p => p.userOrGuest.id === activity.user['id'])) {
              people.push({ userOrGuest: <DisplayUserEmailDto>activity.user, assetIds: [], type: 'user' });
            }
          }
          if (activity.guest) {
            if (!people.find(p => p.userOrGuest.id === activity.guest['id'])) {
              people.push({ userOrGuest: <DisplayGuestEmailDto>activity.guest, assetIds: [], type: 'guest' });
            }
          }

          const person = people.find(p => {
            if (activity.user) return p.userOrGuest.id === activity.user?.['id'];
            if (activity.guest) return p.userOrGuest.id === activity.guest?.['id'];
          });

          if (person) {
            person.assetIds.push(activity.asset);
          }
        });

        return people;
      })
    );
  }

  public getAssetLikeUsers(assetId: string) {
    return this.activityService.getAssetLikeActivity(assetId).pipe(
      take(1),
      map(activities => {
        const users: ((DisplayUser | DisplayGuestDto) & { id: string })[] = [];
        activities.forEach(activity => {
          const user = (activity.user || activity.guest) as (DisplayUser | DisplayGuestDto) & { id: string };
          if (!user) return;
          if (users.some(u => u.id === user.id)) return;
          users.push(user);
        });

        return users;
      })
    );
  }
}
